import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { reactive } from 'vue'
import { cloneDeep } from 'lodash-es'
import DetailForm from './components/DetailForm.vue'
import type { FbuSalesClueEditParams } from '@/typings/api/clueManage'


const __default__ = { name: 'DcCosFbuSalesClueAdd' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const initForm = reactive<FbuSalesClueEditParams.RootObject>({
  contact: {},
  business: { demandInfo: { warehouses: [{}] }, saleInfo: [{}] },
  visitAddress: [{}]
})
const dataForm = reactive<FbuSalesClueEditParams.RootObject>(cloneDeep(initForm))

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(DetailForm, {
            ref: "detailFormRef",
            type: "add",
            isEdit: "",
            value: dataForm,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm) = $event)),
            resetValue: initForm
          }, null, 8, ["value", "resetValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})